const skills = ["HTML", "CSS", "JavaScript", "React JS", "Git/GitHub", "Redux", "Zustand", "React Hooks", "JSON", "Rest API"]

export {
    skills
}